/* eslint react/prop-types: off */
import axios from 'axios';
import './reclamo.css';
import { useState } from 'react';
import Swal from 'sweetalert2';
import { useCookies } from 'react-cookie';
export function DatosPersonales({ setPestania, reclamo, theme }) {
  const [cookies] = useCookies(['user']);
  // cambiar email reclamo
  const [editando, setEditando] = useState(0);
  const [emailUsuario3ro, setEmailUsuario3ro] = useState('');
  const handleCambiarEmailReclamo = async () => {
    if (!emailUsuario3ro) {
      Swal.fire('Error', 'El email no puede estar vacío', 'error');
      return;
    }
    const result = await Swal.fire({
      title: '¿Está seguro que desea cambiar el email vinculado al reclamo?',
      html: `<p>Nuevo Email: <strong>${emailUsuario3ro}</strong></p>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, cambiar',
      cancelButtonText: 'Cancelar',
    });
    if (!result.isConfirmed) {
      setEditando(0);
      setEmailUsuario3ro('');
      return;
    }
    function getFechaFormateada() {
      const ahora = new Date();
      const dia = String(ahora.getDate()).padStart(2, '0');
      const mes = String(ahora.getMonth() + 1).padStart(2, '0');
      const anio = ahora.getFullYear();
      const horas = String(ahora.getHours()).padStart(2, '0');
      const minutos = String(ahora.getMinutes()).padStart(2, '0');
      const segundos = String(ahora.getSeconds()).padStart(2, '0');
      return `${dia}/${mes}/${anio} ${horas}:${minutos}:${segundos}`;
    }
    const fecha = getFechaFormateada();
    try {
      Swal.fire({
        title: 'Procesando...',
        html: 'Por favor espere mientras se actualiza.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      await axios.post('https://reclamosback.agsseguros.online/apiReclamos/empleadosSolicitudes/cambiarUsuarioReclamo', {
        idReclamo: reclamo.id,
        emailNuevo: emailUsuario3ro,
        fechaUltMod: fecha,
      });
      await axios.post('https://back.agsseguros.online/api/mail/delegacionReclamo', {
        mail: reclamo.usuario3ro.email,
        stro: reclamo.nroStro,
      });
      await axios.post('https://back.agsseguros.online/api/mail/avisoNuevoReclamoActivo', {
        mail: emailUsuario3ro,
        stro: reclamo.nroStro,
      });
      Swal.close();
      Swal.fire('¡Listo!', 'El email ha sido actualizado y se enviaron los correos correctamente.', 'success').then(() => {
        window.location.reload();
      });
    } catch (error) {
      Swal.close();
      console.error('Error en proceso:', error);
      Swal.fire('Error', error.response?.data?.error || 'No se pudo completar el cambio. Verifique la conexión o intente nuevamente.', 'error');
      setTimeout(() => window.location.reload(), 1500);
    }
  };
  return (
    <article className={theme === 1 ? 'botonDesplegableAbierto' : 'botonDesplegableAbiertoDark'}>
      <div className='d-flex align-items-center' style={{ paddingTop: '32px' }}>
        <h4 className={theme === 1 ? 'tituloBotonDesplegable' : 'tituloBotonDesplegableDark'}>Datos personales</h4>
        {setPestania && (
          <i className={theme === 1 ? 'bi bi-chevron-down' : 'bi bi-chevron-down text-white'} style={{ marginLeft: 'auto', fontSize: '20px', cursor: 'pointer' }} onClick={() => setPestania(0)}></i>
        )}
      </div>
      <p className={theme === 1 ? 'textoDesplegable' : 'textoDesplegableDark'}>Datos del reclamante</p>
      <div className={theme === 1 ? 'inputReclamo' : 'inputReclamoDark'} style={{ marginTop: '27px' }}>
        <strong>NOMBRE RECLAMANTE:</strong>&nbsp;{reclamo.nombreReclamante}
      </div>
      <div className='d-flex' style={{ gap: '39px', marginTop: '27px' }}>
        <div className={theme === 1 ? 'inputReclamo2' : 'inputReclamo2Dark'}>
          <strong>DNI RECLAMANTE:</strong>&nbsp;{reclamo.dniReclamante}
        </div>
        <div className={theme === 1 ? 'inputReclamo2' : 'inputReclamo2Dark'}>
          <strong>TELEFONO RECLAMANTE:</strong>&nbsp;{reclamo.telefonoReclamante}
        </div>
      </div>
      <div style={{ background: '#ECEAEE', height: '1px', marginTop: '20px' }}></div>
      <p className={theme === 1 ? 'textoDesplegable' : 'textoDesplegableDark'}>Datos del conductor</p>
      <div className={theme === 1 ? 'inputReclamo' : 'inputReclamoDark'} style={{ marginTop: '20px' }}>
        <strong>NOMBRE CONDUCTOR:</strong>&nbsp;{reclamo.nombreConductor}
      </div>
      <div className='d-flex' style={{ gap: '39px', marginTop: '27px' }}>
        <div className={theme === 1 ? 'inputReclamo2' : 'inputReclamo2Dark'}>
          <strong>DNI CONDCUTOR:</strong>&nbsp;{reclamo.dniConductor}
        </div>
        <div className={theme === 1 ? 'inputReclamo2' : 'inputReclamo2Dark'}>
          <strong>TELEFONO CONDUCTOR:</strong>&nbsp;{reclamo.telefonoConductor}
        </div>
      </div>
      <div style={{ background: '#ECEAEE', height: '1px', marginTop: '20px' }}></div>
      <p className={theme === 1 ? 'textoDesplegable' : 'textoDesplegableDark'}>Relato del Siniestro</p>
      <div className={theme === 1 ? 'inputReclamo3' : 'inputReclamo3Dark'} style={{ marginTop: '10px' }}>
        {reclamo.relatoSiniestro}
      </div>
      <div style={{ background: '#ECEAEE', height: '1px', marginTop: '20px' }}></div>
      <p className={theme === 1 ? 'textoDesplegable' : 'textoDesplegableDark'}>Datos del usuario</p>
      <div className=''>
        {editando ? (
          <>
            <input type='email' className='form-control bg-white' value={emailUsuario3ro} onChange={e => setEmailUsuario3ro(e.target.value)} placeholder='Nuevo email' style={{ marginTop: '27px' }} />
            <div className='d-flex gap-2 mt-3'>
              <button className='btn btn-success btn-sm' onClick={handleCambiarEmailReclamo}>
                Guardar
              </button>
              <button
                className='btn btn-secondary btn-sm'
                onClick={() => {
                  setEditando(0);
                  setEmailUsuario3ro('');
                }}>
                Cancelar
              </button>
            </div>
          </>
        ) : (
          <>
            <div className='d-flex gap-2'>
              <div className={theme === 1 ? 'inputReclamo w-100' : 'inputReclamoDark w-100'} style={{ marginTop: '27px' }}>
                <strong>EMAIL:</strong>&nbsp;{reclamo?.usuario3ro?.email}
              </div>
              <div className={theme === 1 ? 'inputReclamo w-100' : 'inputReclamoDark w-100'} style={{ marginTop: '27px' }}>
                <strong>PASSWORD:</strong>&nbsp;{reclamo?.usuario3ro?.password}
              </div>
            </div>
            <div className='d-flex gap-2'>
              <div className={theme === 1 ? 'inputReclamo w-100' : 'inputReclamoDark w-100'} style={{ marginTop: '27px' }}>
                <strong>NOMBRE:</strong>&nbsp;{reclamo?.usuario3ro?.nombre}
              </div>
              <div className={theme === 1 ? 'inputReclamo w-100' : 'inputReclamoDark w-100'} style={{ marginTop: '27px' }}>
                <strong>APELLIDO:</strong>&nbsp;{reclamo?.usuario3ro?.apellido}
              </div>
            </div>
            <div className='d-flex gap-2'>
              <div className={theme === 1 ? 'inputReclamo w-100' : 'inputReclamoDark w-100'} style={{ marginTop: '27px' }}>
                <strong>TELEFONO:</strong>&nbsp;{reclamo?.usuario3ro?.telefono}
              </div>
              <div className={theme === 1 ? 'inputReclamo w-100' : 'inputReclamoDark w-100'} style={{ marginTop: '27px' }}>
                <strong>DNI:</strong>&nbsp;{reclamo?.usuario3ro?.dni}
              </div>
            </div>
            <button className='btn btn-danger btn-sm mt-4' onClick={() => setEditando(true)} disabled={cookies?.user?.titulo === 'lector'}>
              Cambiar Usuario
            </button>
          </>
        )}
      </div>
    </article>
  );
}
